import { Button } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

interface ReopenPeriodButtonProps {
  alertData?: any;
  onClick?: (alertData?: any) => void;
  className?: string;
  testId?: string;
}

const ReopenPeriodButton: React.FC<ReopenPeriodButtonProps> = ({
  alertData,
  onClick,
  className,
  testId,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    // Call the onClick callback if provided
    if (onClick) {
      onClick(alertData);
    }
  };

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '4%',
      }}
      className={className}
    >
      <Button
        variant="text"
        onClick={handleClick}
        size="small"
        data-testid={testId}
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          textTransform: 'none',
          padding: '0',
          minWidth: 'auto',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          },
        }}
      >
        Reopen Period
      </Button>
    </Box>
  );
};

export default ReopenPeriodButton;
